import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';

export class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoUrl: this.props.logoUrl
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div className={css(Styles.orgDetailContainer)}>
        <div className={css(Styles.orgDetailInnerContainer)}>
          <div className={css(Styles.orgDetailContainerTilte)}>
            <p className={css(Styles.orgDetailContainerTiltContent)}>ORG INFO</p>
          </div>

          <div className={css(Styles.orgDetailInnerContent)}>
            <div className={css(Styles.ImgOuterContainer)}>
              <img
                src={this.state.logoUrl}
                onError={() => this.setState({ logoUrl: require('../../assets/images/location-img.svg') })}
                className={css(Styles.ImgContent)} />
            </div>
            <div>
              <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.title}</p>
            </div>
          </div>
        </div>

        <div className={css(Styles.orgDetailInnerContainer, Styles.orgDetailInnerContainerSecondary)}>
          <div className={css(Styles.orgDetailContainerTilte)}>
            <p className={css(Styles.orgDetailContainerTiltContent)}>OVERALL STATUS</p>
          </div>

          <div className={css(Styles.orgDetailInnerContent)}>
            <div className={css(Styles.overrallContainer)}>
              <p className={css(Styles.overrallContainerTitle)}>GUESTS</p>
              <p className={css(Styles.overrallContainerContent, Styles.overrallContainerContentThird)}>{this.props.users.length}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/Stats.js